(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--wall-of-ugc');
  const SWIPER = SECTION.querySelector('.swiper');

  let swiperInstance = null;

  function needsSwiper(containerEl) {
    const wrapper = containerEl.querySelector('.swiper-wrapper') || containerEl;
    return wrapper.scrollWidth > containerEl.clientWidth + 1;
  }

  function enableSwiper(containerEl) {
    const next = containerEl.querySelector('.swiper-button-next');
    const prev = containerEl.querySelector('.swiper-button-prev');

    swiperInstance = new Swiper(containerEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,

      loop: true,
      watchOverflow: false,
      centeredSlides: true,
      centeredSlidesBounds: true,

      navigation: { 
        nextEl: next, 
        prevEl: prev
      },

      mousewheel: { 
        forceToAxis: true 
      },

      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
    });
  }

  function disableSwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  function updateSwiperMode(SWIPER_SELECTOR) {
    if (!SWIPER_SELECTOR) return;

    if (needsSwiper(SWIPER_SELECTOR)) {
      if (!swiperInstance) enableSwiper(SWIPER_SELECTOR);

      SWIPER_SELECTOR.classList.add('is-swiper');
    } else {
      disableSwiper();
      SWIPER_SELECTOR.classList.remove('is-swiper');
    }
  }

  updateSwiperMode(SWIPER);
  window.addEventListener('resize', () => updateSwiperMode(SWIPER));
    
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      if (swiperInstance != null) {
        const blockId = event.detail.blockId;

        const slideIndex = [...SWIPER.querySelectorAll('.swiper-slide')].findIndex(
          el => el.dataset.blockId === blockId
        );
        
        if (slideIndex !== -1) {
          swiperInstance.slideTo(slideIndex);
        }
      }
    });
  }
})();
